import { CommonButton } from 'components/Button'
import { Checkbox } from 'components/Input'
import styled from 'styled-components'
import theme from 'theme_'

import {
  NetworkWizardBottomPanel,
  NetworkWizardContainer,
  NetworkWizardWhiteBlock,
} from '../styles'

export const CreateWLANsContainer = styled(NetworkWizardContainer)`
  gap: 16px;
`

export const CreateWLANsWhiteBlock = styled(NetworkWizardWhiteBlock)`
  padding: 0;
  width: 100%;
`

export const StyledNetworkWizardBottomPanel = styled(NetworkWizardBottomPanel)`
  align-items: center;
  flex-wrap: wrap;
  > button {
    flex: 1;
  }

  @media ${theme.devices.tablet} {
    > button {
      flex: 0;
    }
  }
`

export const CreateWLANsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;

  @media ${theme.devices.tablet} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const CreateWLANsButton = styled(CommonButton)`
  padding: 12px 16px;

  @media ${theme.devices.tablet} {
    padding: 12px 32px;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  flex: 0 0 100%;

  @media ${theme.devices.tablet} {
    flex: 1;
  }
`
